import { StyleSheet } from "react-native";
import { ThemedValues } from 'styles/themed'
import { colorList } from 'utils/colors'

export const textStyles = StyleSheet.create({
	container: {
		flex: 1,
		alignItems: "center",
		justifyContent: "center",
	},
	textCenter: {
		flexDirection: "column",
		textAlign: 'center',
		padding: ThemedValues.marginHorizontal,
	},
	link: {
		color: colorList.BLUE.primary,
		textDecorationLine: 'underline'
	}
});

export const textProps = {
	fit: {
		numberOfLines: 1,
		allowFontScaling: true,
		adjustsFontSizeToFit: true,
	}
}
